/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Modal,
  Input,
  Dropdown,
  Button
} from "semantic-ui-react";
import OrderAgGridTable from "../../../components/common/orderadGridTable";
import { connect } from "react-redux";
import * as yup from "yup";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { translate } from "react-i18next";
import DatePicker from "react-datepicker";
import moment from "moment";

import ReadAxios from "../../axiosComponent/read";
import CreateAxios from "../../axiosComponent/create";
import allAxiosCommonTA from "../../axiosComponent/allAxiosCommonTA";
import inputLRno from "../../common/inputField";
import inputLRDate from "../../common/inputDateField";
import allotVehicle from "../../common/allotVehicle";
import cogoToast from 'cogo-toast';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';


const MarketVehiclePlanning = ({ ...props }) => {
  const [rowData, setRowData] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedVendorsGroup, setSelectedVendorsGroup] = useState([]);

  const [uomSelected, setUomSelected] = useState(null);

  const [bookingID, setBookingID] = useState(props?.props?.bookingIDClicked);

  const [vendorsGroup, setVendorsGroup] = useState([]);
  const [pullfromMaster, setPullfromMaster] = useState(false);


  const [transportationByEnum, setTransportationByEnum] = useState([{ key: '1', text: 'Transporter', value: 'Transporter' }, { key: '1', text: 'Shipper', value: 'Shipper' }]);
  const [loadingDoneBy, setLoadingDoneBy] = useState(null);
  const [unloadingDoneBy, setUnloadingDoneBy] = useState(null);
  const [insuredBy, setInsuredBy] = useState(null);
  const [advancePayment, setAdvancePayment] = useState('80');


  let todaysDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
  let broadcastEndDate = moment(moment(new Date()).add(120, 'm')).format('YYYY-MM-DD HH:mm');
  const [broadcastStartDatetime, setBroadcastStartDatetime] = useState(todaysDate);
  const [broadcastEndDatetime, setBroadcastEndDatetime] = useState(broadcastEndDate);

  var vendorIndex = 0;

  useEffect(() => {
    getMarketVehicle()
    getAllVendors()
    getAllVendorsGroup()
  }, []);

  const getMarketVehicle = () => {
    allAxiosCommonTA({ url: "/vehicle/availability/booking/" + bookingID, method: "get", getValues: `ownership_type_id=2&` })
      .then((response) => {
        setRowData(response.data.data)
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const getAllVendors = () => {
    ReadAxios({ url: `transporterMaster` })
      .then((res) => {
        let dataArray = res.data.resultSet;
        setVendorsState(dataArray)
      })
      .catch((err) => setVendors([]));
  };


  const setVendorsState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.transporterName,
        key: item.transporterCode,
        value: item.transporterCode,
      };
    });
    setVendors(result);
  };

  const getAllVendorsGroup = () => {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
    })
      .then((res) => {
        let dataArray = res.data.resultSet;
        setVendorsGroupState(dataArray)
      })
      .catch((err) => setVendorsGroup([]));
  };


  const setVendorsGroupState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vendorGroupName,
        key: item.vendorGroupId,
        value: item.vendorGroupId,
      };
    });
    setVendorsGroup(result);
  };

  const handlePullRateFromVendors = (e) => {
    if (e.target.checked) {
      setPullfromMaster(true)
    } else {
      setPullfromMaster(false)
    }
  }

  var columnDefs = [
    {
      headerName: "SR. No.",
      //field: "", // source
      valueGetter: "node.rowIndex + 1",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Vehicle No.",
      field: "vehicle_number", // source
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "LR No.",
      field: "", // source
      cellRenderer: "inputLRno",
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "LR Date",
      field: "", // source
      cellRenderer: "inputLRDate",
      minWidth: 200,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Vehicle Type",
      field: "vehicle_type", // source
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Status",
      field: "status", // source
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Idle Status",
      field: "idle_status", // source
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "Empty KM Run",
      field: "empty_km_run", // source
      minWidth: 180,
      sortable: true,
      filter: true,
    },
    {
      headerName: "",
      field: "", // source
      cellRenderer: "allotVehicle",
      minWidth: 180,
      sortable: true,
      filter: true
    }
  ]

  var frameworkcomponent = {
    inputLRno: inputLRno,
    inputLRDate: inputLRDate,
    allotVehicle: allotVehicle
  };

  let broadcastElement = () => {
    let allVendors = [...selectedVendors, ...selectedVendorsGroup];

    if (document?.getElementById('pullRateFromVendors').checked) {
      if (document?.getElementById('pull-offered-rate')?.value.length <= 0) {
        cogoToast.warn("Please provide offer rate.")
      } else if (uomSelected.length <= 0) {
        cogoToast.warn("Please select UOM.")
      } else if (allVendors.length <= 0) {
        cogoToast.warn("Please select Partner.")
      } else {
        broadcastVehicle()
      }
    } else {
      if (allVendors.length <= 0) {
        cogoToast.warn("Please select Partner.")
      } else {
        broadcastVehicle()
      }
    }
  }

  let broadcastVehicle = () => {
    let pullRates = document?.getElementById('pull-offered-rate')?.value;
    let emailNotification = document?.getElementById('email-notification')?.checked;
    let smsNotofication = document?.getElementById('sms-notification')?.checked;
    let mobileNotofication = document?.getElementById('mobile-app-notification')?.checked;
    let returnLoad = document?.getElementById('yes-returnload')?.value;

    if (localStorage.getItem('customerNumber') == "2") {
      let loadingCharges = document?.getElementById('loading-charges')?.value;
      let unloadingCharges = document?.getElementById('unloading-charges')?.value;
      let creditPeriodForSettlement = document?.getElementById('credit-period-for-settlement')?.value;
    }


    let broadcast_details = {
      allVendors: [...selectedVendors, ...selectedVendorsGroup],
      vendors: [...selectedVendors],
      vendor_groups: [...selectedVendorsGroup],
      broadcast_start_datetime: broadcastStartDatetime,
      broadcast_end_datetime: broadcastEndDatetime,
      // shipment_id: +props.shipmentId,
      email: emailNotification,
      sms: smsNotofication,
      mobile: mobileNotofication,
      base_rate: null,
    }

    if (localStorage.getItem('customerNumber') == "2") {
      broadcast_details.loading_done_by = loadingDoneBy
      broadcast_details.loading_charges = loadingCharges
      broadcast_details.unloading_done_by = unloadingDoneBy
      broadcast_details.unloading_charges = unloadingCharges
      broadcast_details.insured_by = insuredBy
      broadcast_details.advance_payment = advancePayment
      broadcast_details.credit_period_for_settlement = creditPeriodForSettlement
    }

    if (document?.getElementById('pullRateFromVendors').checked) {
      broadcast_details.pull_rates = pullRates;
      broadcast_details.uom = uomSelected;
      broadcast_details.return_load = returnLoad;
    }
    const element = props?.data?.vehicle_availability_id;
    //const shipment_id = props.orders[index].shipment.vendor_shipment_id;
    let broadcast_start_datetime = broadcastStartDatetime;
    let broadcast_end_datetime = broadcastEndDatetime;

    allAxiosCommonTA({
      url: "/bookings/indent/planning/allot", method: "post",
      Items: {
        broadcast_details,
        action_code: "BRDCST",
        booking_id: props.props.bookingIDClicked,
      }
    })
      .then((response) => {
        console.log(response)
        cogoToast.success("Alotted.")
        window.location.reload()
      })
      .catch((err) => {
        cogoToast.error(err.message)
      });
  }

  let getUOMSelected = (event, data) => {
    setUomSelected(data.value)
  }

  let getloadingSelected = (event, data) => {
    setLoadingDoneBy(data.value)
  }
  let getunloadingSelected = (event, data) => {
    setUnloadingDoneBy(data.value)
  }
  let getInsured = (event, data) => {
    setInsuredBy(data.value)
  }

  let getvendorSelected = (event, data) => {
    divideVendorsAndVendorGroup(data)
  }

  const divideVendorsAndVendorGroup = (data) => {
    let temp = data.options.filter((ele) => {
      return ele.value == data.value[data.value.length - 1];
    })[0];
    if (temp?.raw?.transporterMasterId) {
      let setVendor = [...selectedVendors];
      setVendor = [...setVendor, temp.raw.transporterMasterId]
      setSelectedVendors(setVendor)

    } else {
      let setVendorGroup = [...selectedVendorsGroup];
      setVendorGroup = [...setVendorGroup, temp.raw.vendorGroupId];
      setSelectedVendorsGroup(setVendorGroup)
    }
  };

  return (
    <div>
      <div>
        <OrderAgGridTable
          columnDefs={columnDefs}
          pagination={false}
          titleBarTitle=""
          extracomponents={frameworkcomponent}
          rowData={rowData}
          suppressRowClickSelection={true}
          enableCellChangeFlash={true}
          keyIndex={"u_id"}
          showFilter={false}
          bookingID={bookingID}
          ownershipTypeId='1'
        />
      </div>
      <div className="display-flex-center-justify-spacebtwn margin-top-30 width-80cent">
        <div className="display-flex-center-justify-spacebtwn width-45cent">
          <div className="required-form-element">BroadCast Start Date & Time</div>
          <div>
            <DatePicker
              isClearable
              popperClassName="dateTime"
              selected={(broadcastStartDatetime && new Date(broadcastStartDatetime)) || null}
              onChange={(val) => {
                let temp_date = moment(val).format('YYYY-MM-DD HH:mm:ss');
                setBroadcastStartDatetime(temp_date)
              }}
              autoComplete="off"
              showTimeSelect
              timeFormat="hh:mm"
              popperClassName="dateTime"
              dateFormat="dd/MM/yyyy HH:mm"
              timeIntervals={5}
              customInput={<Input defaultValue={broadcastStartDatetime} className="dateWidth" icon="calendar alternate outline" iconPosition="left" />}
            />
          </div>
        </div>
        <div className="display-flex-center-justify-spacebtwn width-45cent">
          <div className="required-form-element">BroadCast End Date & Time</div>
          <div>
            <DatePicker
              isClearable
              popperClassName="dateTime"
              selected={(broadcastEndDatetime && new Date(broadcastEndDatetime)) || null}
              onChange={(val) => {
                let temp_date = moment(val).format('YYYY-MM-DD HH:mm:ss');
                setBroadcastEndDatetime(temp_date)
              }}
              autoComplete="off"
              showTimeSelect
              timeFormat="hh:mm"
              popperClassName="dateTime"
              dateFormat="dd/MM/yyyy HH:mm"
              timeIntervals={5}

              customInput={<Input defaultValue={broadcastEndDatetime} className="dateWidth" icon="calendar alternate outline" iconPosition="left" />}
            />
          </div>
        </div>
      </div>
      <div className="margin-top-30">
        <div>
          <input type="checkbox" id="pullRateFromVendors" name="pullRateFromVendors" onClick={handlePullRateFromVendors} />
          <label for="pullRateFromVendors" className="margin-left-20">Pull Rate From Vendors</label>
        </div>
      </div>
      <div className="margin-top-30 width-60cent">
        <div className="required-form-element">Vendors</div>
        <div className="width-50cent margin-top-10 width-40cent">
          <Dropdown
            name="allVendors"
            clearable
            multiple
            search
            id="allVendors-dropdown"
            style={{ width: "100%" }}
            selection
            placeholder="Select Vendor"
            options={[...vendorsGroup, ...vendors]}
            onChange={(event, data) => getvendorSelected(event, data)}
          />
        </div>
      </div>
      <div className="margin-top-30">
        <label>Notification</label>

        <input className="margin-left-20" type="checkbox" id="email-notification" name="email" />
        <label className="margin-left-20" for="email">Email</label>

        <input className="margin-left-20" type="checkbox" id="sms-notification" name="sms" />
        <label className="margin-left-20" for="sms">SMS</label>

        <input className="margin-left-20" type="checkbox" id="mobile-app-notification" name="mobile-app" />
        <label className="margin-left-20" for="mobile-app">Mobile App</label>
      </div>
      {pullfromMaster
        ?
        <>
          <div className="display-flex-center-justify-spacebtwn width-60cent margin-top-30">
            <div className="width-45cent">
              <div className="required-form-element">Offered Rate</div>
              <div className="margin-top-10">
                <Input
                  id="pull-offered-rate"
                  className="width-100cent"
                  icon="rupee sign"
                  type="number"
                  iconPosition='left'
                />
              </div>
            </div>
            <div className="width-45cent">
              <div className="required-form-element">UoM</div>
              <div className="margin-top-10">
                <Dropdown
                  id="pull-uom-master"
                  name="uom"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  onChange={(event, data) => getUOMSelected(event, data)}
                  options={[
                    { key: "1", text: "KG", value: "kg" },
                    { key: "2", text: "Ton", value: "ton" },
                    { key: "3", text: "Trip", value: "trip" },
                    { key: "4", text: "KM", value: "km" },
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="margin-top-30">
            <label>Return Load</label>

            <input className="margin-left-20" type="radio" id="yes-returnload" name="ReturnLoad" value="no" />
            <label className="margin-left-20" for="yes-load">Yes</label>

            <input className="margin-left-20" type="radio" id="no-returnload" name="ReturnLoad" value="yes" />
            <label className="margin-left-20" for="no-load">No</label>
          </div>
        </>
        :
        null}

      {localStorage.getItem('customerNumber') == "2" ?
        <>
          <div className="display-flex-center-justify-spacebtwn width-60cent margin-top-30">
            <div className="width-45cent">
              <div className="">Loading Done By</div>
              <div className="margin-top-10">
                <Dropdown
                  id="loading-done-by"
                  name="loading-done-by"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  onChange={(event, data) => getloadingSelected(event, data)}
                  options={transportationByEnum}
                />
              </div>
            </div>
            <div className="width-45cent">
              <div className="">Loading Charges</div>
              <div className="margin-top-10">
                <Input
                  id="loading-charges"
                  className="width-100cent"
                  icon="rupee sign"
                  type="number"
                  iconPosition='left'
                />
              </div>
            </div>
          </div>

          <div className="display-flex-center-justify-spacebtwn width-60cent margin-top-30">
            <div className="width-45cent">
              <div className="">Unloading Done By</div>
              <div className="margin-top-10">
                <Dropdown
                  id="unloading-done-by"
                  name="unloading-done-by"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  onChange={(event, data) => getunloadingSelected(event, data)}
                  options={transportationByEnum}
                />
              </div>
            </div>
            <div className="width-45cent">
              <div className="">Unloading Charges</div>
              <div className="margin-top-10">
                <Input
                  id="unloading-charges"
                  className="width-100cent"
                  icon="rupee sign"
                  type="number"
                  iconPosition='left'
                />
              </div>
            </div>
          </div>

          <div className="display-flex-center-justify-spacebtwn width-60cent margin-top-30">
            <div className="width-45cent">
              <div className="">Insured By</div>
              <div className="margin-top-10">
                <Dropdown
                  id="insured-by"
                  name="insured-by"
                  clearable
                  style={{ width: "100%", fontWeight: "normal" }}
                  selection
                  onChange={(event, data) => getInsured(event, data)}
                  options={transportationByEnum}
                />
              </div>
            </div>
            <div className="width-45cent">
              <div className="">Advance Payment</div>
              <div className="margin-top-10">
                <div>
                  <Slider min={80} max={100} defaultValue={80} marks={{ 80: 80, 100: 100 }} onChange={(data) => { setAdvancePayment(data) }} handle={(data) => { }} />
                  <div className="margin-left-40-cent">{advancePayment} %</div>
                </div>
              </div>
            </div>
          </div>

          <div className="display-flex-center-justify-spacebtwn width-60cent margin-top-30">
            <div className="width-45cent">
              <div className="">Credit Period For Settlement</div>
              <div className="margin-top-10">
                <Input
                  id="credit-period-for-settlement"
                  className="width-100cent"
                  icon="rupee sign"
                  type="number"
                  iconPosition='left'
                />
              </div>
            </div>
          </div>
        </>
        : null}

      <div>

      </div>
      <div className="margin-top-30 text-center">
        <Button
          type="submit"
          size="mini"
          className="w3-blue w3-round w3-hover-blue"
          onClick={broadcastElement}
        >
          Broadcast
        </Button>
      </div>
    </div>
  );
};

export default MarketVehiclePlanning;
